import BlockShell from "./BlockShell";
import { PosterWall } from "../PosterWall";

// Porchfest-style community poster wall, scoped to this festival's slug.
const PosterWallBlock = ({ block, festival }) => {
  const cfg = block.config || {};
  const slug = cfg.event_slug || festival?.slug || "community";
  return (
    <BlockShell block={block}>
      <PosterWall eventSlug={slug} emptyText={cfg.empty_text || "Posters and photos land here as the community shares them."} />
    </BlockShell>
  );
};

export default PosterWallBlock;
